import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {ApiConfig} from '@employee-configs/api.config';
import * as EmployeeModels from '@employee-models/index';
import {BaseServiceClass} from '@ui-app/services/base.service';
import {UserDataServiceUI} from '@ui-app/app.module';
import {catchError} from 'rxjs/operators';
import {HttpRequestCustomHeaderNames, HttpRequestCustomHeaderValues} from '@ui-app/http-interceptors/http-loader.interceptor';


@Injectable({
    providedIn: 'root'
})
export class UserDataService extends BaseServiceClass implements UserDataServiceUI {

    constructor(
        private httpClient: HttpClient
    ) {
        super();
    }

    getUserData(): Observable<EmployeeModels.DM.IUserData> {
        return this.httpClient.get(ApiConfig.Account.getUserData) as Observable<EmployeeModels.DM.IUserData>;
    }

    signOut(): Observable<null> {
        return this.httpClient.get(ApiConfig.Account.signOut) as Observable<null>;
    }

    getUserPhoto(userAlias: string): Observable<Blob | null> {
        const url = ApiConfig.Users.userPhoto.replace('{userAlias}', userAlias);
        const headers: HttpHeaders = new HttpHeaders({
            [HttpRequestCustomHeaderNames.DisableLoader]: HttpRequestCustomHeaderValues.LoaderDisabled,
        });
        return this.httpClient.get(url, { responseType: 'blob', headers }).pipe(
            catchError(error => of(null))
        );
    }

    getUserAccesForEmployeeSearch(userEmail:string): Observable<boolean> {
        //const url =  `https://cognito.dbadge.deloitte.com/employee/api/photo/checkaccess?email=`+userEmail;
        const url =  ApiConfig.EmployeeSearch.checkAccessForEmployeeSearchTab+userEmail;
        return this.httpClient.get(url) as Observable<boolean>;
   }
}
